import axios from "axios";
import { PaymentIntentData } from "../models/paymentIntent";
import { SERVER_URL } from "../config";
import { Authorization } from "./authorization";
import { SubscriptionData } from "../models/subscription";

export const getPaymentIntentSecret = async (voucherCode: string | undefined, videoId: String, addAnalysis: boolean, affiliatePrePaidToken: string | null) => {
  const res = await axios.post<PaymentIntentData>(SERVER_URL + "/payment/paymentIntent", { voucherCode, videoId, addAnalysis, affiliateToken: affiliatePrePaidToken }, {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });
  if (res) {
    return res.data.paymentIntentSecret;
  }
  return null;
}

export const syncSubscription = async () => {
  await axios.post(SERVER_URL + "/payment/syncSubscription", {}, {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });
}

export const paymentSubscription = async (voucherCode: string | undefined, videoId: string) => {
  return await axios.post<SubscriptionData>(SERVER_URL + "/payment/subscription", { voucherCode }, {
    headers: {
      Authorization: await Authorization.AuthToken()
    }
  });
}